import { render, staticRenderFns } from "./editFazhan.vue?vue&type=template&id=48fbd1ae&scoped=true"
import script from "./editFazhan.vue?vue&type=script&lang=js"
export * from "./editFazhan.vue?vue&type=script&lang=js"
import style0 from "./editFazhan.vue?vue&type=style&index=0&id=48fbd1ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbd1ae",
  null
  
)

export default component.exports